import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import Layout from '../components/Layout';
import STATES_PROVINCES from '../statesProvinces';
import {api} from '../../api';


export default function EditVehicle() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState(null);

  useEffect(() => {
    api(`/vehicles/${id}`).then(r => r.json()).then(v =>
      setForm({ year: v.year || '', make: v.make || '', model: v.model || '', vin: v.vin || '', color: v.color || '', mileage: v.mileage || '', licensePlate: v.licensePlate || '', licensePlateState: v.licensePlateState || '', status: v.status || 'Active' })
    );
  }, [id]);

  if (!form) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const body = { ...form, year: parseInt(form.year), mileage: form.mileage ? parseInt(form.mileage) : null };
    const res = await api(`/vehicles/${id}`, { method: 'PUT', body: JSON.stringify(body) });
    if (res.ok) navigate(`/vehicles/${id}`);
  };

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  return (
    <Layout>
      <div className="bg-white rounded-lg shadow max-w-2xl">
        <div className="p-4 md:p-6 border-b">
          <h1 className="text-2xl font-bold text-gray-900">Edit Vehicle</h1>
        </div>
        <form onSubmit={handleSubmit} className="p-4 md:p-6 space-y-4">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Year *</label>
              <input name="year" type="number" required value={form.year} onChange={onChange} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-600" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Make *</label>
              <input name="make" required value={form.make} onChange={onChange} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-600" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Model *</label>
              <input name="model" required value={form.model} onChange={onChange} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-600" />
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">VIN</label>
              <input name="vin" value={form.vin} onChange={onChange} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-600" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Color</label>
              <input name="color" value={form.color} onChange={onChange} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-600" />
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Mileage</label>
              <input name="mileage" type="number" value={form.mileage} onChange={onChange} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-600" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">License Plate</label>
              <input name="licensePlate" value={form.licensePlate} onChange={onChange} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-600" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">State / Province</label>
              <select name="licensePlateState" value={form.licensePlateState} onChange={onChange} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-600">
                <option value="">Select...</option>
                {STATES_PROVINCES.map(g => (
                  <optgroup key={g.group} label={g.group}>
                    {g.options.map(s => <option key={s} value={s}>{s}</option>)}
                  </optgroup>
                ))}
              </select>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
              <select name="status" value={form.status} onChange={onChange} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-600">
                <option>Active</option>
                <option>In Service</option>
                <option>Inactive</option>
              </select>
            </div>
          </div>
          <div className="flex gap-3 pt-4">
            <button type="submit" className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700">Save</button>
            <button type="button" onClick={() => navigate(`/vehicles/${id}`)} className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50">Cancel</button>
          </div>
        </form>
      </div>
    </Layout>
  );
}
